<div class="flex flex-middle flex-justify-center p-t-3 p-b-3"
     [class.bg-col-5]="!transparent">
    <ng-content></ng-content>
</div>